module.exports = __webpack_public_path__ + "static/Ralphs_pin_hover-c1eaa0d5bc0bb92146503839c66a70e3.png";